import {
  Card,
  PageHeaderSkeleton,
  Row,
  Skeleton,
  Stack,
} from '@leanin/ui';

// Generic skeleton for an admin section that's shaped like a PageHeader +
// one or more form Cards. Used by Overview, Visibility, Archive, and
// Calendar sections — all of them resolve to a form-style page.

type Props = {
  /** Number of card blocks to render. Default: 1. */
  cards?: number;
  /** Whether the page header should reserve space for a primary action. */
  withAction?: boolean;
  /** Approximate number of rows per card (each row = a label + input pair). */
  rowsPerCard?: number;
};

export function AdminFormPageSkeleton({
  cards = 1,
  withAction = false,
  rowsPerCard = 4,
}: Props) {
  return (
    <Stack gap="lg">
      <PageHeaderSkeleton withAction={withAction} />
      {Array.from({ length: cards }, (_, ci) => (
        <Card key={ci} pad="default">
          <Stack gap="lg">
            {Array.from({ length: rowsPerCard }, (__, ri) => (
              <Stack key={ri} gap="sm">
                <Skeleton width={120} height={13} rounded="sm" />
                <Row gap="md" wrap>
                  <Skeleton
                    height={36}
                    rounded="md"
                    style={{ flex: '1 1 240px', minWidth: 0 }}
                  />
                  <Skeleton
                    height={36}
                    rounded="md"
                    style={{ flex: '1 1 240px', minWidth: 0 }}
                  />
                </Row>
              </Stack>
            ))}
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}
